import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { logError } from '../lib/logger';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    async function exchange() {
      if (!sessionId) { navigate("/admin", { replace: true }); return; }
      try {
        const res = await fetch(`${API_URL}/api/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sessionId },
          credentials: "include",
        });
        const data = await res.json().catch(() => ({}));
        window.history.replaceState(null, "", "/admin");
        if (!res.ok) {
          navigate("/admin", { replace: true, state: { authError: data.detail || "Sign-in failed." } });
          return;
        }
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (err) {
        logError("Auth callback failed", err);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { authError: "Sign-in failed. Please try again." } });
      }
    }
    exchange();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-[#003A70]" />
      <p className="text-gray-500 text-sm">Signing you in...</p>
    </div>
  );
}
